<!-- src/views/new-tip/CampaignForm.vue -->
<template>
  <v-container fluid style="max-width: 900px">
    <div class="d-flex align-center mb-4">
      <v-btn icon :to="{ name: 'new-tip.campaigns.index' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h1 class="text-h5 font-weight-medium ml-2">
        {{ isEdit ? 'Modifier la campagne' : 'Nouvelle campagne' }}
      </h1>
    </div>

    <v-card outlined :loading="loading">
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-text-field
            v-model="form.name" label="Nom de la campagne *"
            :rules="[rules.required]" outlined dense
          />

          <v-textarea
            v-model="form.description" label="Description"
            outlined dense rows="3" auto-grow
          />

          <v-row>
            <v-col cols="12" sm="6">
              <v-menu v-model="startMenu" :close-on-content-click="false" max-width="290">
                <template #activator="{ on }">
                  <v-text-field
                    :value="form.start_date" label="Date de début *"
                    prepend-inner-icon="mdi-calendar" readonly
                    :rules="[rules.required]" outlined dense v-on="on"
                  />
                </template>
                <v-date-picker v-model="form.start_date" no-title @input="startMenu = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu v-model="endMenu" :close-on-content-click="false" max-width="290">
                <template #activator="{ on }">
                  <v-text-field
                    :value="form.end_date" label="Date de fin *"
                    prepend-inner-icon="mdi-calendar" readonly
                    :rules="[rules.required, rules.afterStart]" outlined dense v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="form.end_date" no-title
                  :min="form.start_date" @input="endMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-select
            v-model="form.status" label="Statut *"
            :items="statusItems" :rules="[rules.required]" outlined dense
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text :to="{ name: 'new-tip.campaigns.index' }">Annuler</v-btn>
        <v-btn color="primary" :loading="saving" :disabled="!valid" @click="save">
          {{ isEdit ? 'Enregistrer' : 'Créer' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { CAMPAIGN_STATUSES } from '@/constants/newTip';

export default {
  name: 'NewTipCampaignForm',
  props: { id: { type: [String, Number], default: null } },
  data() {
    return {
      valid: false,
      startMenu: false,
      endMenu: false,
      form: { name: '', description: '', start_date: null, end_date: null, status: 'draft' },
      statusItems: CAMPAIGN_STATUSES.map(s => ({ value: s.value, text: s.label })),
      rules: {
        required: v => !!v || 'Ce champ est obligatoire',
        afterStart: v => !this.form.start_date || !v || v >= this.form.start_date
          || 'La date de fin doit être après la date de début',
      },
    };
  },
  computed: {
    isEdit() { return !!this.id; },
    loading() { return this.$store.getters['newTip/isLoading']('campaigns'); },
    saving() { return this.$store.getters['newTip/isLoading']('saving'); },
  },
  methods: {
    ...mapActions('newTip', ['fetchCampaign', 'createCampaign', 'updateCampaign']),
    async load() {
      if (this.isEdit) {
        const c = await this.fetchCampaign(this.id);
        this.form = {
          name: c.name,
          description: c.description,
          start_date: c.start_date,
          end_date: c.end_date,
          status: c.status,
        };
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      try {
        if (this.isEdit) {
          await this.updateCampaign({ id: this.id, payload: this.form });
        } else {
          await this.createCampaign(this.form);
        }
        this.$router.push({ name: 'new-tip.campaigns.index' });
      } catch (err) {
        // Le toast d'erreur global du projet doit l'attraper
        console.error(err);
      }
    },
  },
  mounted() { this.load(); },
};
</script>
